import { BaseEntity } from "../../../models/concrete/BaseEntity.mjs";
export class FilterPage extends BaseEntity {
  title;
  altTitle;
  text;
  slug;
  imageId;
  searchData;
  bottomText;
  yandexCollectionId;
  categoryId;
  url;
  constructor(data) {
    super(data);
    this.title = data.title;
    this.altTitle = data.alt_title;
    this.text = data.text;
    this.slug = data.slug;
    this.imageId = data.image_id;
    this.searchData = data.search_data;
    this.bottomText = data.bottom_text;
    this.yandexCollectionId = data.yandex_collection_id;
    this.categoryId = data.category_id;
    this.url = data.url;
  }
  toJSON() {
    return { ...this };
  }
}
